import { DatabaseObject, DatabaseObjectType } from '../models/databaseObjectTypes';

export function mapDatabaseObjectRows(options: {
  rows: Record<string, unknown>[];
  objectType: DatabaseObjectType;
  connectionId: string;
  database: string;
}): DatabaseObject[] {
  return options.rows.map((row) => {
    const { id, name, schema_name, object_type, ...extra } = row;
    return {
      id: String(id ?? ''),
      name: String(name ?? ''),
      schema: String(schema_name ?? ''),
      type: options.objectType,
      connectionId: options.connectionId,
      metadata: { database: options.database, ...extra },
    };
  });
}

